import { STORAGE_NAME } from "../config/constances";

export const setStorage = async (keyName = '', data: any, isObject = false): Promise<boolean> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let dataToSet: any = data;
  if (isObject) {
    dataToSet = JSON.stringify(data);
  }
  try {
    const prefix = STORAGE_NAME;
    const key = `${prefix}.${keyName}`;
    await localStorage.setItem(key, dataToSet);
    return true;
  } catch (error) {
    throw error;
  }
}

export const getStorage = async (keyName = '', isObject = false): Promise<any> => {
  try {
    const prefix = STORAGE_NAME;
    const key = `${prefix}.${keyName}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let dataToGet: any = '';
    dataToGet = await localStorage.getItem(key);
    if (isObject) {
      dataToGet = JSON.parse(dataToGet);
    }
    return dataToGet;
  } catch (error) {
    throw error;
  }
}

export const removeStorage = async (keyName = ''): Promise<boolean> => {
  try {
    const prefix = STORAGE_NAME;
    const key = `${prefix}.${keyName}`;
    await localStorage.removeItem(key);
    return true;
  } catch (error) {
    throw error;
  }
}